var audio_rtlignore_default = {
  "fontElementMap": "ASbA8",
  "container": "_1AJoL",
  "customPlayer": "tw49X",
  "slim": "-i3O2",
  "playPauseButton": "phSiC",
  "coverImage": "TtN-b",
  "trackDetailsContainer": "xXP7J",
  "controlsContainer": "_3YpCF",
  "controlsGroup": "ws8-p",
  "sliderContainer": "BqQy6",
  "audioDuration": "cFNVT",
  "isLoading": "wyxgt",
  "audioDetails": "G4FnZ",
  "authorName": "YatP8",
  "title": "DV73A",
  "dropdownMenuWrapper": "SCwwd",
  "dropdownSelectedButton": "HXOh-",
  "dropdownContent": "gK8a7",
  "dropdownContentWithIcon": "P8TJK",
  "audioLoader": "-wb-b"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
